// NOTE: This enum defines which data source is used to display the integrated reminders
// `INTERNAL` source set up the `fieldState` by using the result of the internal handle/query `useUploadFilesMutation` (cannot be modified)
// `EXTERNAL` source allow setting up the `fieldState` by using the result of the external handle `handleFiles`
// -> Bringing back data is *not* required with `EXTERNAL` source
export enum UseFormDropZoneStateSource {
  INTERNAL = 'internal', // Result of the GQL query `useUploadFilesMutation`
  EXTERNAL = 'external', // Result of the external handler `handleFiles` (optionnal)
}
